import React from 'react';
import { Button, Icon, Input } from "semantic-ui-react";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
  convertFromHTML,
} from "draft-js";
import { createEvent, editEvent, showEvent } from "../../api";
import { useLocation } from "react-router-dom";
import qs from "qs";
import { IMG_PATH } from "../../constants";
import LoadingTop from "../../component/LoadingTop";

const EditEvent = (props) => {
  const location = useLocation();
  const [name, setName] = React.useState("");
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty())
  const [modal, setModal] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [thumbnail, setThumbnail] = React.useState(null);
  const [loadingBtn, setLoadingBtn] = React.useState(false);
  const search = qs.parse(location.search, {ignoreQueryPrefix: true});
  const id = search.id;

  const handleSubmit = async () => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setLoadingBtn(true);
    try {
      await editEvent({name, content: html, id});
      window.history.back();
    } catch (err) {}
    setLoadingBtn(false);
  }

  const loadData = async () => {
    try {
      const res = await showEvent(id);
      setName(res.data.name);
      initContent(res.data.content);
      setThumbnail(`${IMG_PATH}/${res.data.thumbnail}`)
    } catch (err) {}
  }

  const initContent = (html) => {
    const contentState =
      html == null
        ? null
        : ContentState.createFromBlockArray(convertFromHTML(html));
    const es =
      contentState == null
        ? EditorState.createEmpty()
        : EditorState.createWithContent(contentState);
    setEditorState(es);
  };

  React.useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4 px-5">
          <div className="row">
            <div className="col-md-8 d-flex align-items-center mb-md-0 mb-3">
              <Input 
                className="w-100"
                placeholder="Nama Event"
                value={name}
                onChange={(e) => setName(e.target.value)}
              >
                <input />
              </Input>
            </div>
          </div>
        </div> 
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container shadow-sm py-3 border-0">
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label>Gambar Utama</label>
                    <img src={thumbnail}  alt="" className="w-100 img-thumbnail" />
                  </div>
                  <div className="form-group">
                    <Editor
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      editorState={editorState}
                      onEditorStateChange={(e) => setEditorState(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-5">
                    <label>Tanggal Event</label>
                    <input type="date" name="" className="form-control" id=""/>
                  </div>
                  <Button color='green' fluid size="lg" className="mb-2" loading={loadingBtn} onClick={handleSubmit}>Simpan</Button>
                  <Button color='light' fluid size="lg" onClick={() => window.history.back()}>Batal</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditEvent
